import { separatorHeight } from '@/features/pos/components/ProductCatalog/parts/ProductList/constants'
import { FC } from 'react'
import { View } from 'react-native'

const ItemSeparator: FC = () => {
    return <View style={{ height: separatorHeight, width: '100%' }} />
}

export default ItemSeparator
